export const testimonials = [
  {
    name: "Ramesh S.",
    text: "Quick and reliable ambulance service. The vehicle was clean and the driver helped us throughout.",
    location: "Bengaluru",
  },
  {
    name: "Kavitha R.",
    text: "We had to shift my mother to a hospital in Bengaluru urgently at night. The ambulance arrived within minutes and the medical team stayed calm and focused throughout the journey. I’ll always be grateful for their timely help.",
    location: "Bengaluru",
  },
  {
    name: "Abdul Rahman",
    text: "Very professional and kind staff. My father was taken safely to the hospital during midnight. Thank you for your service.",
    location: "Hubli",
  },
   {
    name: "Thomas D.",
    text: "Needed to transfer my cousin from Mangalore to Bengaluru by train ambulance. The coordination was smooth and they stayed with us until hospital admission. Professional from start to finish.",
    location: "Mangaluru",
  },
  {
    name: "Ayesha B.",
    text: "Very thankful for their help during our family emergency. The staff was respectful and handled everything with care while transporting my grandmother.",
    location: "Shivamogga",
  },
  {
    name: "Anitha Patel",
    text: "We had to transport a loved one who had passed away. The team handled the situation with dignity and patience, taking care of all arrangements without causing any additional stress to the family.",
    location: "Davangere",
  },
  {
    name: "Prakash J",
    text: "Their team helped us shift my wife from one hospital to another with great care. Everything was smooth and well-coordinated, and they treated us with genuine concern.",
    location: "Mysuru",
  },
];
